const RangeSlider = (function(window, $) {

    function RangeSlider(target) {
        const filterGroup = $(target);

        filterGroup.append($("<div class='range-slider-wrapper'></div>"));

        const rangeSlider = filterGroup.find('.range-slider-wrapper');
        const inputs = filterGroup.find("input");

        const inputMin = $(inputs[0]);
        const inputMax = $(inputs[1]);

        // this data comes from the CMS settings in page /boeken 
        const min = parseInt(inputMin.data('limit'));
        const max = parseInt(inputMax.data('limit'));

        // this is the actual value of the input fields above the slider
        let inputMinVal = $(inputs[0]).val();
        let inputMaxVal = $(inputs[1]).val();

        // make sure the values are not higher or lower than the limits set in the CMS settings in page /boeken 
        if(inputMinVal < min) {
            inputMinVal = min;
        }
        if(inputMaxVal > max) { 
            inputMaxVal = max;
        }

        rangeSlider.slider({
            range: true,
            min: min,
            max: max,
            step: 1,
            values: [
                inputMinVal,
                inputMaxVal
            ],
            slide: function(event, ui) {
                inputMin.val(ui.values[0]);
                inputMax.val(ui.values[1]);

                showSelected();
            },
            change: function(event, ui) {
                //Trigger search only if slider is changed by mouse.
                if(typeof event.originalEvent !== 'undefined') {
                    //Only trigger on search page
                    if ($('#search').length > 0) {
                        rangeSlider.closest('form').trigger('submit')
                    }
                }

                showSelected();
            },
            create: function() {
                let values = $(this).slider("option", "values");
                inputMin.val(values[0]);
                inputMax.val(values[1]);

                showSelected();
            }
        });

        // Input value to Integer.
        const toInt = input => {
            let val = Number(input);

            if (Number.isInteger(val)) {
                return Number(val);
            } else {
                return 0;
            }
        };

        function rangeIsChanged() {
            return parseInt(inputMin.val()) !== min || parseInt(inputMax.val()) !== max;
        }

        function showSelected () {
            let selectedDiv = filterGroup.parent().prev('.range-selected');

            selectedDiv.removeClass('is-hidden').find('span').html(inputMin.val() + ' - ' + inputMax.val());

            if(!rangeIsChanged()) {
                selectedDiv.addClass('is-hidden');
            }
        };

        // Bind onchange event to inputs.
        inputMin.on('change',function() {
            let amount_min = toInt($(this).val());
            let amount_max = toInt(inputMax.val());

            if (amount_min >= amount_max) {
                amount_min = amount_max;
            }

            rangeSlider.slider("values", 0, amount_min);
        });

        inputMax.on('change',function() {
            let amount_max = toInt($(this).val());
            let amount_min = toInt(inputMin.val());

            if (amount_max <= amount_min) {
                amount_max = amount_min;
            }

            rangeSlider.slider("values", 1, amount_max);
        });
    }


    return RangeSlider;

}(window, jQuery));

export {RangeSlider};